import PropTypes from 'prop-types';
import { useFormContext, Controller } from 'react-hook-form';
import MuiPhoneNumber from 'mui-phone-number';

export default function RHFTextFieldMUI({ name, helperText, type, ...other }) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <MuiPhoneNumber 
        sx={{ '& svg': { height: '1em', }, }}
        {...field}
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
         />
      
      )}
    />
  );
}

RHFTextFieldMUI.propTypes = {
  helperText: PropTypes.object,
  name: PropTypes.string,
  type: PropTypes.string,
};
